/* Loomlac "Complete the look" that reacts to the shopper (owner 4 Nov 2026).
   Where: product page (under Add to cart) and the "Added to cart" pop-up.
   Order of suggestions: 1) a product she looked at (this browser, last 12 product pages) that goes with this one,
   2) pairs from real orders ("Often bought together": Go-To + jersey 8, Kimono + Flow Basic 26, Summer Basic + Terra 23,
   Ease + Puff 17, Ease + Foggy 9, Drift + Flow Basic 12, Kimono + Go-To 10), 3) styling pairs ("Wear it with").
   Skips what is already in the bag (and its whole family) and anything sold out. One tap adds to the bag. */
(function () {
  if (window.__lcPairs) return; window.__lcPairs = 1;
  var COATS = ['willow-wool-coat-black', 'willow-wool-coat-nude', 'willow-wool-coat-brown', 'willow-wool-coat-gray', 'willow-wool-coat-white'];
  var GOTO = ['go-to-sweatshirt-mroon', 'go-to-sweatshirt-brown'];
  var JERSEY = ['beige-jersy-set', 'light-brown-jersey-set', 'black-jersey-set'];
  var TRICOT = ['black-flow-basic', 'off-white-flow-basic'];
  var KIMONO = ['off-white-flow-kimono', 'black-flow-kimono'];
  var EASE = ['ease-basic-shirt-oxford-in-orange', 'ease-basic-shirt-oxford-in-olive', 'ease-basic-shirt-copy', 'ease-basic-shirt-oxford-in-blue'];
  var PAIRS = {
    goto: [['jersey', JERSEY, 'bought'], ['willow', COATS, 'style']],
    willow: [['goto', GOTO, 'style'], ['jersey', JERSEY, 'style'], ['tricot', TRICOT, 'style']],
    jersey: [['goto', GOTO, 'bought'], ['willow', COATS, 'style']],
    kimono: [['tricot', TRICOT, 'bought'], ['goto', GOTO, 'bought']],
    tricot: [['kimono', KIMONO, 'bought'], ['willow', COATS, 'style']],
    drift: [['tricot', TRICOT, 'bought'], ['jersey', JERSEY, 'style']],
    summer: [['terra', ['terra-pants'], 'bought'], ['eve', ['eve-cotton-basic'], 'style']],
    terra: [['summer', ['flow-cotton-basic'], 'bought'], ['ease', EASE, 'style'], ['eve', ['eve-cotton-basic'], 'style']],
    eve: [['terra', ['terra-pants'], 'style']],
    ease: [['puff', ['puff-high-low-shirt-oxford-in-orange'], 'bought'], ['foggy', ['foggy-sky-cotton-muslin'], 'bought'], ['terra', ['terra-pants'], 'style']],
    puff: [['ease', EASE, 'bought']],
    foggy: [['ease', EASE, 'bought']],
    vida: [['jersey', JERSEY, 'style']]
  };
  var WHY = { viewed: 'You looked at this', bought: 'Often bought together', style: 'Wear it with' };
  function fam(h) {
    if (!h) return null;
    if (/^willow-wool-coat/.test(h)) return 'willow';
    if (/^go-to-sweatshirt/.test(h)) return 'goto';
    if (/^drift-sweatshirt/.test(h)) return 'drift';
    if (/jers(e)?y-set$/.test(h)) return 'jersey';
    if (/flow-kimono$/.test(h)) return 'kimono';
    if (/flow-basic$/.test(h)) return 'tricot';
    if (h === 'flow-cotton-basic') return 'summer';
    if (h === 'terra-pants') return 'terra';
    if (h === 'eve-cotton-basic') return 'eve';
    if (/^ease-basic-shirt/.test(h)) return 'ease';
    if (/^foggy|poplin-in-yellow-copy$/.test(h)) return 'foggy';
    if (/^puff-high-low-shirt-oxford/.test(h)) return 'puff';
    if (/^vida-set/.test(h)) return 'vida';
    return null;
  }
  function money(c) { return Math.round(c / 100).toLocaleString('en-US') + ' EGP'; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(u, w) { if (!u) return ''; u = u.indexOf('//') === 0 ? 'https:' + u : u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function rvGet() { try { return JSON.parse(localStorage.getItem('lc_rv') || '[]'); } catch (e) { return []; } }
  function rvPush(h) { try { var a = rvGet().filter(function (x) { return x !== h; }); a.unshift(h); localStorage.setItem('lc_rv', JSON.stringify(a.slice(0, 12))); } catch (e) {} }
  var cache = {};
  function prod(h) { if (!cache[h]) cache[h] = fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); return cache[h]; }
  function cart() { return fetch('/cart.js').then(function (r) { return r.json(); }).catch(function () { return { items: [] }; }); }

  function pick(ctx, c, n) {
    var groups = PAIRS[fam(ctx)] || [], ok = groups.map(function (g) { return g[0]; });
    var inCart = {}, famInCart = {};
    (c.items || []).forEach(function (i) { inCart[i.handle] = 1; famInCart[fam(i.handle)] = 1; });
    var list = [];
    rvGet().forEach(function (h) { if (h !== ctx && ok.indexOf(fam(h)) > -1) list.push({ h: h, why: 'viewed' }); });
    groups.forEach(function (g) { g[1].forEach(function (h) { list.push({ h: h, why: g[2] }); }); });
    list = list.filter(function (x) { return x.h !== ctx && !inCart[x.h] && !famInCart[fam(x.h)]; });
    var out = [], usedFam = {};
    return list.reduce(function (p, x) {
      return p.then(function () {
        if (out.length >= n || usedFam[fam(x.h)]) return;
        return prod(x.h).then(function (pr) { if (pr && pr.available && out.length < n && !usedFam[fam(x.h)]) { usedFam[fam(x.h)] = 1; out.push({ p: pr, why: x.why }); } });
      });
    }, Promise.resolve()).then(function () { return out; });
  }
  function bagMatch(ctx, c) {
    var ok = (PAIRS[fam(ctx)] || []).map(function (g) { return g[0]; });
    var m = (c.items || []).filter(function (i) { return i.handle !== ctx && ok.indexOf(fam(i.handle)) > -1; })[0];
    return m ? m.product_title : null;
  }
  function row(s, compact) {
    var p = s.p, v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
    var sel = '';
    if (p.variants.length > 1) {
      sel = '<select class="lc-pair__sel" aria-label="' + esc(p.options[0] && p.options[0].name || 'Option') + '">' + p.variants.map(function (x) {
        return '<option value="' + x.id + '"' + (x.id === v.id ? ' selected' : '') + (x.available ? '' : ' disabled') + '>' + esc(x.title) + (x.available ? '' : ' (sold out)') + '</option>';
      }).join('') + '</select>';
    }
    var cmp = v.compare_at_price && v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '';
    return '<div class="lc-pair__row' + (compact ? ' lc-pair__row--c' : '') + '" data-v="' + v.id + '">' +
      '<a href="' + p.url + '"><img src="' + img(p.featured_image, 180) + '" alt="' + esc(p.title) + '" width="72" height="72" loading="lazy"></a>' +
      '<div class="lc-pair__info"><span class="lc-pair__why">' + WHY[s.why] + '</span><a class="lc-pair__t" href="' + p.url + '">' + esc(p.title) + '</a>' +
      '<span class="lc-pair__p">' + money(v.price) + cmp + '</span>' + sel + '</div>' +
      '<button type="button" class="lc-pair__add">Add</button></div>';
  }
  function bind(box) {
    box.querySelectorAll('.lc-pair__row').forEach(function (r) {
      var b = r.querySelector('.lc-pair__add'), sel = r.querySelector('.lc-pair__sel');
      b.addEventListener('click', function () {
        if (b.disabled) return;
        b.disabled = true; b.textContent = '...';
        var id = sel ? sel.value : r.dataset.v;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
          .then(function (res) { if (!res.ok) throw 0; b.textContent = 'Added'; b.classList.add('is-done'); bubble(); setTimeout(renderPdp, 600); })
          .catch(function () { b.disabled = false; b.textContent = 'Add'; });
      });
    });
  }
  function bubble() {
    fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (j) {
      var el = document.getElementById('cart-icon-bubble'); if (!el || !j['cart-icon-bubble']) return;
      var s = new DOMParser().parseFromString(j['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (s) el.innerHTML = s.innerHTML;
    }).catch(function () {});
  }

  var host = document.getElementById('lc-pair');
  function renderPdp() {
    if (!host) return;
    var ctx = host.dataset.handle;
    cart().then(function (c) {
      return pick(ctx, c, 2).then(function (list) {
        var bag = bagMatch(ctx, c);
        if (!list.length && !bag) { host.hidden = true; return; }
        var html = '<p class="lc-pair__h">Complete the look</p>';
        if (bag) html += '<p class="lc-pair__bag">Goes with the <b>' + esc(bag) + '</b> in your bag</p>';
        if (list.length) {
          var a = list[0].p, av = a.variants.filter(function (x) { return x.available; })[0] || a.variants[0];
          var sum = +host.dataset.price + av.price, was = (+host.dataset.cmp || +host.dataset.price) + (av.compare_at_price || av.price);
          html += '<div class="lc-pair__look"><img src="' + host.dataset.img + '" alt="" width="56" height="56"><span>+</span><img src="' + img(a.featured_image, 120) + '" alt="" width="56" height="56">' +
            '<div class="lc-pair__sum"><small>Both together</small><b>' + money(sum) + '</b>' + (was > sum ? '<s>' + money(was) + '</s><em>You save ' + money(was - sum) + '</em>' : '') + '</div></div>';
          html += list.map(function (s) { return row(s, false); }).join('');
        }
        host.innerHTML = html; host.hidden = false; bind(host);
      });
    });
  }
  function renderPop(h, title) {
    var anchor = document.getElementById('cart-notification-product'); if (!anchor) return;
    var box = document.getElementById('lc-pair-pop');
    if (!box) { box = document.createElement('div'); box.id = 'lc-pair-pop'; box.className = 'lc-pair lc-pair--pop'; anchor.insertAdjacentElement('afterend', box); }
    box.hidden = true; box.innerHTML = '';
    cart().then(function (c) {
      return pick(h, c, 2).then(function (list) {
        if (!list.length) return;
        box.innerHTML = '<p class="lc-pair__h">Wear it with your ' + esc(title || 'piece') + '</p>' + list.map(function (s) { return row(s, true); }).join('');
        box.hidden = false; bind(box);
      });
    });
  }
  if (host) { rvPush(host.dataset.handle); renderPdp(); }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
      if (!ev || ev.source !== 'product-form' || !ev.cartData || !ev.cartData.handle) return;
      renderPop(ev.cartData.handle, ev.cartData.product_title);
      setTimeout(renderPdp, 300);
    });
  }
})();
